import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const RodRequestDetailContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  overflow-y: hidden;
  min-width: 260px;
  width: 260px;
  background: white;
`;
